@charset "UTF-8";

/* src/app/views/legal-text-contract/legal-text-contract-colombia/legal-text-contract-colombia.component.scss */
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 20px 32px;
  margin: 0 auto 24px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
}
.title-terminos {
  position: relative;
  left: -1.5em;
  padding-bottom: 20px;
  font-weight: bold;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title-padding {
  padding: 2px;
}
.text-top {
  position: relative;
  width: 100%;
  text-align: justify;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
}
.text-initial {
  position: relative;
  left: -1.5em;
  font-size: 10pt;
  width: 101%;
}
.sub-title-top {
  position: relative;
  padding-top: 10px;
  left: -1em;
  font-weight: bold;
}
.custom-list-roman {
  list-style: none;
  counter-reset: custom-counter;
  padding-left: 4.5em;
}
.custom-list-roman .li-roman {
  position: relative;
  padding-bottom: 2px;
  font-size: 10pt;
}
.custom-list-roman .li-roman:before {
  position: absolute;
  left: -4.5em;
  counter-increment: custom-counter;
  content: "(" counter(custom-counter, upper-roman) ") ";
}
.text-second {
  position: relative;
  padding-top: 5px;
  left: -1.5em;
  font-size: 10pt;
}
.article {
  column-count: 2;
  column-gap: 3rem;
  column-rule: 3px;
}
.sub-title {
  position: relative;
  padding-top: 10px;
  left: -1em;
}
.custom-list-number {
  list-style: none;
  counter-increment: main-counter;
  padding-left: 0;
}
.custom-list-number .li-number {
  position: relative;
  padding-top: 10px;
  padding-left: 1em;
  font-size: 10pt;
  counter-increment: sub-counter;
}
.custom-list-number .li-number:before {
  position: absolute;
  left: -1em;
  content: counters(main-counter, ".") "." counters(sub-counter, ".") ". ";
}
.custom-list-text-one {
  list-style: none;
  padding-left: 0;
  left: -5em;
  counter-reset: main-counter;
}
.custom-list-text-one .li-text-one {
  position: relative;
  font-size: 10pt;
  padding-left: 0;
  left: -1em;
  counter-reset: sub-counter;
}
.custom-list-text-one .li-text-one:before {
  position: absolute;
  margin-right: 5px;
}
.custom-list-text-two {
  list-style: none;
  padding-left: 0;
  left: -2em;
  counter-reset: main-counter;
}
.custom-list-text-two li {
  width: 106%;
}
.custom-list-text-two .li-text-two {
  position: relative;
  padding-top: 10px;
  font-size: 10pt;
  padding-left: 0;
  left: -2em;
  counter-reset: sub-counter;
}
.custom-list-text-two .li-text-two-sub {
  position: relative;
  font-size: 10pt;
  padding-left: 0;
  left: -2em;
  counter-reset: sub-counter;
}
.custom-list-text-two .li-text-two:before {
  position: absolute;
  margin-right: 5px;
  counter-reset: sub-counter;
}
.li-text-three {
  position: sticky;
  padding-top: 10px;
  font-size: 10pt;
  counter-reset: sub-counter;
}
.custom-list-text-for {
  list-style: none;
  padding-left: 2.8em;
  counter-reset: main-counter;
}
.custom-list-text-for li {
  width: 101%;
}
.custom-list-text-for .li-text-for {
  position: relative;
  top: -16px;
  font-size: 10pt;
  padding-left: 0;
  left: 0em;
  counter-reset: sub-counter;
}
.custom-list-text-for .li-text-for:before {
  position: absolute;
  margin-right: 5px;
  counter-reset: sub-counter;
}
.custom-list-number-trhee {
  list-style: none;
  counter-increment: main-counter;
  padding-left: 0.5em;
}
.custom-list-number-trhee .li-number-trhee {
  position: relative;
  padding-top: 10px;
  padding-left: 1em;
  font-size: 10pt;
  counter-increment: sub-counter;
}
.custom-list-number-trhee .li-number-trhee:before {
  position: absolute;
  left: -2em;
  content: counters(main-counter, ".") "." counters(sub-counter, ".") "." counter(third-counter, decimal);
}
.ul-ifem {
  list-style: none;
  padding-top: 2px;
  padding-left: 0em;
}
.ul-ifem .li-ifem {
  position: relative;
  padding-top: 2px;
  left: -1em;
  font-size: 10pt;
}
.ul-ifem .li-ifem:before {
  position: absolute;
  content: "-";
  left: -1em;
}
.ul-ifem li {
  width: 103%;
}
.ul-circle {
  list-style: none;
  padding-top: 2px;
  padding-left: 3em;
}
.ul-circle .li-circle {
  position: relative;
  padding-top: 8px;
  font-size: 10pt;
}
.ul-circle .li-circle:before {
  position: absolute;
  content: "\2022";
  left: -1em;
  top: -0.18em;
  font-size: 2.5em;
}
.custom-list-text {
  position: relative;
  padding-left: 0em;
  list-style: none;
}
.custom-list-text .li-text {
  position: relative;
  padding-top: 10px;
  font-size: 10pt;
}
.custom-list-number .li-text:before {
  position: absolute;
  margin-right: 5px;
}
.custom-list-alphabet {
  list-style: none;
  padding-top: 10px;
  padding-left: 1em;
}
.custom-list-alphabet .li-alphabet {
  position: relative;
  padding-top: 10px;
  font-size: 10pt;
  counter-increment: custom-counter;
}
.custom-list-alphabet .li-alphabet:before {
  position: absolute;
  content: counter(custom-counter, lower-alpha) ") ";
  margin-right: 5px;
  left: -2em;
}
.title-negrito {
  font-weight: bold;
}
.span-underlined-dashed {
  text-decoration: underline;
  text-decoration-color: #0062af;
  text-decoration-style: dashed;
}
.a-edit {
  color: #000000;
}
.a-edit:hover,
.a-edit-blue:hover {
  color: #008de2;
}
.a-edit-blue {
  color: #0062af;
}
.custom-text-data {
  position: relative;
  padding-top: 30px;
  font-size: 10pt;
  text-align: center;
}
/*# sourceMappingURL=legal-text-contract-colombia.component-RN6F5OSJ.css.map */
